import { defineStore } from 'pinia'

const useSidebarStore = defineStore('sidebar', {
    state: () => ({
        appDiscovered: false,
        appModalShown: false,
        chatShown: true,
        playerShown: true
    }),
    persist: {
        paths: [
            'appDiscovered',
            'chatShown',
            'playerShown'
        ]
    }
})

export {
    useSidebarStore
}
